import {
  getCookie,
  setCookie
} from "../components/layout/cookies/CookieFunctions";
import { languages } from "./Languages";

// Create a list of supported languages that can be used throughout the app
export const supportedLanguages = languages.map((lang) => ({
  value: lang.value,
  label: lang.label,
  countryCode:
    lang?.countryCode ||
    lang?.value?.split("-")?.[1] ||
    lang?.value?.split("-")?.[0]?.toUpperCase() ||
    ""
}));

export function getLanguageCookie() {
  const language = getCookie("language");
  if (language) return language;

  const tempLanguage = getCookie("tempLanguage");
  if (tempLanguage) return tempLanguage;

  const navigatorLanguage =
    navigator?.language || navigator?.userLanguage || "en-US";

  if (navigatorLanguage && supportedLanguages.includes(navigatorLanguage)) {
    setCookie("tempLanguage", navigatorLanguage);
    return navigatorLanguage;
  }

  // Default to English if no cookie or localStorage value is found
  setCookie("tempLanguage", "en-US");
  return "en-US";
}

export function setLanguageCookie(language) {
  if (!language) return;

  setCookie("language", language);
  setCookie("tempLanguage", language);
}
